(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page"]) return;
  try {
    
  (() => {
    const init = (scope = document) => {
      scope.querySelectorAll('[data-wc-senior-localized]').forEach(root => {
        if (root.dataset.wcSeniorReady) return;
        root.dataset.wcSeniorReady = 'true';
        root.addEventListener('click', event => {
          const header = event.target.closest('.faq-item-header');
          if (header && root.contains(header)) header.closest('.faq-item')?.classList.toggle('is-open');
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
    else init();
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warmcore-applications-immersive"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const defaults = {
      'ai-development': ['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/ai-development.webp?v=1783405661', 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/ai-development-bg.webp?v=1783405663'],
      'education': ['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/education.webp?v=1783405662', 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/education-bg.webp?v=1783405661'],
      'elder-care': ['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/elder-care.webp?v=1783405662', 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/elder-care-bg.webp?v=1783405662'],
      'hospital-reception': ['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/hospital-reception.webp?v=1783405662', 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/hospital-reception-bg.webp?v=1783405662'],
      'hotel-reception': ['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/hotel-reception.webp?v=1783405662', 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/hotel-reception-bg.webp?v=1783405662'],
      'museum-guide': ['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/museum-guide.webp?v=1783405661', 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/museum-guide-bg.webp?v=1783405661'],
      'kol-live-streaming': ['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/kol-live-streaming.webp?v=1783405661', 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/kol-live-streaming-bg.webp?v=1783405662'],
      'meeting-assistant': ['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/meeting-assistant.webp?v=1783405661', 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/meeting-assistant-bg.webp?v=1783405661'],
      'office-reception': ['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/office-reception.webp?v=1783405661', 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/office-reception-bg.webp?v=1783405663'],
      'personal-companion': ['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/personal-companion.webp?v=1783405662', 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/personal-companion-bg.webp?v=1783405676']
    };

    const initialized = new WeakSet();

    function init(root) {
      if (!root || initialized.has(root)) return;
      initialized.add(root);

      const scenes = [...root.querySelectorAll('[data-wc-ia-scene]')];
      if (!scenes.length) return;

      const image = root.querySelector('[data-wc-ia-image]');
      const background = root.querySelector('[data-wc-ia-background]');
      const dots = root.querySelector('[data-wc-ia-dots]');
      const sceneList = root.querySelector('.wc-ia-parity__scenes');

      const set = (selector, value) => {
        const el = root.querySelector(selector);
        if (el) el.textContent = value || '';
      };

      const pad = value => String(value).padStart(2, '0');
      let index = 0;
      let timer;
      let inView=false;

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const render = (next, { scrollScene = true } = {}) => {
        index = (next + scenes.length) % scenes.length;
        const scene = scenes[index];
        const fallback = defaults[scene.dataset.key] || defaults['personal-companion'];
        const src = scene.dataset.image || fallback[0];
        const bg = scene.dataset.background || fallback[1];

        if (image) {
          image.src = src;
          image.alt = `${scene.dataset.title || 'Warmcore application'} application scene`;
        }

        if (background) background.style.backgroundImage = `url("${bg}")`;

        set('[data-wc-ia-category]', scene.dataset.category);
        set('[data-wc-ia-title]', scene.dataset.title);
        set('[data-wc-ia-description]', scene.dataset.description);
        set('[data-wc-ia-proof]', scene.dataset.proof);
        set('[data-wc-ia-status-title]', scene.dataset.title);
        set('[data-wc-ia-count]', `${pad(index + 1)} / ${pad(scenes.length)}`);

        const link = root.querySelector('[data-wc-ia-link]');
        if (link) {link.href = scene.dataset.link || '#';link.setAttribute('aria-label',`${link.textContent.trim()}: ${scene.dataset.title}`);}
        root.dataset.activeScene=scene.dataset.key;

        scenes.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
        [...dots.children].forEach((item, itemIndex) => {item.classList.toggle('is-active', itemIndex === index);item.setAttribute('aria-current',String(itemIndex===index));});


      };

      const stop = () => window.clearTimeout(timer);

      const schedule = () => {
        stop();
        if (reduced || !inView || document.hidden || root.matches(':hover, :focus-within')) return;

        timer = window.setTimeout(() => {
          render(index + 1);
          schedule();
        }, Number(root.dataset.autoplayMs || 5000));
      };

      scenes.forEach((scene, sceneIndex) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', scene.dataset.title || `Application ${sceneIndex + 1}`);
        dot.addEventListener('click', () => {
          render(sceneIndex);
          schedule();
        });

        dots.appendChild(dot);

        scene.addEventListener('click', () => {
          render(sceneIndex);
          schedule();
        });
      });

      root.querySelector('[data-wc-ia-prev]')?.addEventListener('click', () => {
        render(index - 1);
        schedule();
      });

      root.querySelector('[data-wc-ia-next]')?.addEventListener('click', () => {
        render(index + 1);
        schedule();
      });

            root.addEventListener('pointerenter',stop);root.addEventListener('pointerleave',schedule);
      root.addEventListener('focusin',stop);root.addEventListener('focusout',()=>setTimeout(schedule,0));
      document.addEventListener('visibilitychange',()=>document.hidden?stop():schedule());
      render(0, { scrollScene: false });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(entries => {
          entries.forEach(entry => {inView=entry.isIntersecting;inView?schedule():stop();});
        }, { rootMargin: '-25% 0px' }).observe(root);
      } else {
        inView=true; schedule();
      }
    }

    const initAll = scope => (scope || document).querySelectorAll('[data-wc-ia-parity]').forEach(init);

    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => initAll(document)) : initAll(document);

    document.addEventListener('shopify:section:load', event => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warmcore-applications"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakMap();
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function initWarmcoreApplications(root) {
      if (!root || initialized.has(root)) return;

      const sceneScript = root.querySelector("[data-wc-ia-scenes]");
      if (!sceneScript) return;

      let scenes = [];
      try {
        scenes = JSON.parse(sceneScript.textContent || "[]").filter((scene) => scene && scene.image && scene.background);
      } catch (error) {
        return;
      }

      if (!scenes.length) return;

      const els = {
        bgA: root.querySelector("[data-bg-a]"),
        bgB: root.querySelector("[data-bg-b]"),
        card: root.querySelector("[data-main-card]"),
        mainImage: root.querySelector("[data-main-image]"),
        mainCategory: root.querySelector("[data-main-category]"),
        mainCount: root.querySelector("[data-main-count]"),
        mainTitle: root.querySelector("[data-main-title]"),
        mainDescription: root.querySelector("[data-main-description]"),
        mainLink: root.querySelector("[data-main-link]"),
        mainProofTitle: root.querySelector("[data-main-proof-title]"),
        mainProofCopy: root.querySelector("[data-main-proof-copy]"),
        railIndex: root.querySelector("[data-rail-index]"),
        railTitle: root.querySelector("[data-rail-title]"),
        prevButtons: Array.from(root.querySelectorAll("[data-prev]")),
        nextButtons: Array.from(root.querySelectorAll("[data-next]")),
        dots: root.querySelector("[data-dots]")
      };

      let activeIndex = 0;
      let visibleBg = 0;
      let animating = false;
      let autoplayTimer = null;
      let hasEnteredViewport = false;
      let autoplayActive = false;
      let observer = null;

      const proofLabel = root.dataset.proofLabel || "Application Scene";
      const proofFallback = root.dataset.proofFallback || "Practical application scene";
      const wrap = (index) => (index + scenes.length) % scenes.length;
      const imageText = (scene) => scene.title + " application scene";
      const twoDigit = (index) => String(index + 1).padStart(2, "0");

      scenes.forEach((scene) => {
        const img = new Image();
        img.src = scene.image;
        const bg = new Image();
        bg.src = scene.background || scene.image;
      });

      function setText(selector, value) {
        const el = root.querySelector(selector);
        if (el) el.textContent = value || "";
      }

      function setPreview(kind, index) {
        const scene = scenes[index];
        const image = root.querySelector(`[data-preview-${kind}-image]`);
        if (image) {
          image.src = scene.image;
          image.alt = imageText(scene);
        }
        setText(`[data-preview-${kind}-category]`, scene.category);
        setText(`[data-preview-${kind}-title]`, scene.title);
        setText(`[data-preview-${kind}-description]`, scene.description);
      }

      function buildDots() {
        if (!els.dots) return;
        els.dots.innerHTML = "";
        scenes.forEach((scene, index) => {
          const button = document.createElement("button");
          button.type = "button";
          button.className = "wc-ia-dot";
          button.setAttribute("aria-label", scene.title);
          button.addEventListener("click", () => {
            goTo(index, index > activeIndex ? 1 : -1, true);
          });
          els.dots.appendChild(button);
        });
      }

      function updateDots() {
        if (!els.dots) return;
        Array.from(els.dots.children).forEach((dot, index) => {
          dot.setAttribute("aria-current", index === activeIndex ? "true" : "false");
        });
      }

      function renderContent(index) {
        const scene = scenes[index];
        const farPrevIndex = wrap(index - 2);
        const prevIndex = wrap(index - 1);
        const nextIndex = wrap(index + 1);
        const farNextIndex = wrap(index + 2);

        if (els.mainImage) {
          els.mainImage.src = scene.image;
          els.mainImage.alt = imageText(scene);
        }
        if (els.mainCategory) els.mainCategory.textContent = scene.category || "";
        if (els.mainCount) els.mainCount.textContent = twoDigit(index) + " / " + twoDigit(scenes.length - 1);
        if (els.mainTitle) els.mainTitle.textContent = scene.title || "";
        if (els.mainDescription) els.mainDescription.textContent = scene.description || "";
        if (els.mainLink) els.mainLink.href = scene.link || "#";
        if (els.mainProofTitle) els.mainProofTitle.textContent = proofLabel;
        if (els.mainProofCopy) els.mainProofCopy.textContent = scene.proof || proofFallback;
        if (els.railIndex) els.railIndex.textContent = twoDigit(index) + " / " + twoDigit(scenes.length - 1);
        if (els.railTitle) els.railTitle.textContent = scene.title || "";

        setPreview("far-prev", farPrevIndex);
        setPreview("prev", prevIndex);
        setPreview("next", nextIndex);
        setPreview("far-next", farNextIndex);
        updateDots();
      }

      function setBackground(index) {
        const current = visibleBg === 0 ? els.bgA : els.bgB;
        const next = visibleBg === 0 ? els.bgB : els.bgA;
        if (!current || !next) return;
        next.style.backgroundImage = `url("${scenes[index].background || scenes[index].image}")`;
        current.classList.remove("is-visible");
        next.classList.add("is-visible");
        visibleBg = visibleBg === 0 ? 1 : 0;
      }

      function clearAutoplayTimer() {
        if (autoplayTimer) {
          window.clearTimeout(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function scheduleAutoplay() {
        if (!autoplayActive || reduceMotion) return;
        clearAutoplayTimer();
        autoplayTimer = window.setTimeout(() => {
          autoplayTimer = null;
          goTo(activeIndex + 1, 1, false);
        }, 3000);
      }

      function startAutoplay() {
        if (reduceMotion) return;
        autoplayActive = true;
        if (!autoplayTimer && !animating) {
          scheduleAutoplay();
        }
      }

      function stopAutoplay() {
        autoplayActive = false;
        clearAutoplayTimer();
      }

      function revealSection() {
        if (root.classList.contains("is-ready")) return;
        window.requestAnimationFrame(() => {
          root.classList.add("is-ready");
        });
      }

      function goTo(nextIndex, direction = 1, userInitiated = false) {
        nextIndex = wrap(nextIndex);
        if (nextIndex === activeIndex || animating) return;

        if (userInitiated) {
          clearAutoplayTimer();
        }

        animating = true;
        setBackground(nextIndex);
        root.classList.add("is-switching");

        window.setTimeout(() => {
          activeIndex = nextIndex;
          renderContent(activeIndex);
          root.classList.remove("is-switching");
          animating = false;
          scheduleAutoplay();
        }, 320);
      }

      function handleKeydown(event) {
        if (!root.classList.contains("is-ready")) return;
        if (event.key === "ArrowLeft") goTo(activeIndex - 1, -1, true);
        if (event.key === "ArrowRight") goTo(activeIndex + 1, 1, true);
      }

      buildDots();
      if (els.bgA) els.bgA.style.backgroundImage = `url("${scenes[0].background || scenes[0].image}")`;
      renderContent(activeIndex);

      if ("IntersectionObserver" in window) {
        observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              revealSection();
              if (!hasEnteredViewport) {
                hasEnteredViewport = true;
                if (activeIndex !== 0) {
                  activeIndex = 0;
                  setBackground(0);
                  renderContent(0);
                }
              }
              startAutoplay();
            } else {
              stopAutoplay();
            }
          });
        }, { rootMargin: "-28% 0px -28% 0px", threshold: 0 });

        observer.observe(root);
      } else {
        revealSection();
        startAutoplay();
      }

      els.prevButtons.forEach((button) => {
        button.addEventListener("click", () => goTo(activeIndex - 1, -1, true));
      });

      els.nextButtons.forEach((button) => {
        button.addEventListener("click", () => goTo(activeIndex + 1, 1, true));
      });

      window.addEventListener("keydown", handleKeydown);

      initialized.set(root, () => {
        stopAutoplay();
        if (observer) observer.disconnect();
        window.removeEventListener("keydown", handleKeydown);
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll("[data-wc-ia]").forEach(initWarmcoreApplications);
    }

    function cleanupAll(scope) {
      (scope || document).querySelectorAll("[data-wc-ia]").forEach((root) => {
        const cleanup = initialized.get(root);
        if (cleanup) {
          cleanup();
          initialized.delete(root);
        }
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => initAll(document));
    } else {
      initAll(document);
    }

    document.addEventListener("shopify:section:load", (event) => initAll(event.target));
    document.addEventListener("shopify:section:unload", (event) => cleanupAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warmcore-butterfly-proof-worlds"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const path = root.querySelector('[data-flight-path]');
      const butterfly = root.querySelector('[data-flight-butterfly]');
      if (!path || !butterfly || !path.getTotalLength) return;
      const length = path.getTotalLength();
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let raf = 0;
      const render = () => {
        raf = 0;
        const rect = root.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const travel = Math.max(1, rect.height - window.innerHeight * .4);
        const progress = reducedMotion.matches ? .12 : Math.min(1, .12 + Math.max(0, -rect.top) / travel * .88);
        const point = path.getPointAtLength(length * progress);
        const before = path.getPointAtLength(Math.max(0, length * (progress - .002)));
        const after = path.getPointAtLength(Math.min(length, length * (progress + .002)));
        const angle = reducedMotion.matches ? 0 : Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI + 90;
        const opacity = progress > .82 ? Math.pow((1 - progress) / .18, 1.35) : 1;
        butterfly.style.transform = `translate3d(${point.x / 1200 * rect.width}px,${point.y / 4100 * rect.height}px,0) translate(-50%,-50%) rotate(${angle}deg)`;
        butterfly.style.opacity = `${opacity}`;
      };
      const request = () => { if (!raf) raf = requestAnimationFrame(render); };
      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request, { passive: true });
      reducedMotion.addEventListener('change', request);
      root.wcProofCleanup = () => {
        window.cancelAnimationFrame(raf);
        window.removeEventListener('scroll', request);
        window.removeEventListener('resize', request);
        reducedMotion.removeEventListener('change', request);
        delete root.dataset.ready;
      };
      request();
    };
    const all = root => (root || document).querySelectorAll('[data-wc-butterfly-proof]').forEach(mount);
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => all()) : all();
    document.addEventListener('shopify:section:load', event => all(event.target));
    document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-wc-butterfly-proof]').forEach(root => root.wcProofCleanup?.()));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warmcore-embodied-interface"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const items = [...section.querySelectorAll('[data-capability]')];
      const markers = [...section.querySelectorAll('[data-region-button]')];
      const headMarkers = [...section.querySelectorAll('[data-head-sensor]')];
      const image = section.querySelector('[data-focus-image]');
      const label = section.querySelector('[data-focus-label]');
      const focusDescription = section.querySelector('[data-focus-description]');
      const title = section.querySelector('[data-title]');
      const description = section.querySelector('[data-description]');
      const tags = section.querySelector('[data-tags]');
      const count = section.querySelector('[data-count]');
      const images = {
        neck: 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/warmcore-neck-cutaway-20261022.webp?v=1792647776',
        eye: 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/eye.webp?v=1784263562',
        ear: 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/ear.webp?v=1784202656',
        mouth: 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/mouth.webp?v=1784202639',
        brain: 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/brain.webp?v=1784202655',
        arm: 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/warmcore-hand-transparent-20261022.webp?v=1792647776',
        leg: 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/foot_v2.webp?v=1784264109'
      };
      const headCopy = {
        neck: [section.dataset.neckTitle, section.dataset.neckDescription, section.dataset.neckTags],
        eye: [section.dataset.eyeTitle, section.dataset.eyeDescription, section.dataset.eyeTags],
        ear: [section.dataset.earTitle, section.dataset.earDescription, section.dataset.earTags],
        mouth: [section.dataset.mouthTitle, section.dataset.mouthDescription, section.dataset.mouthTags],
        brain: [section.dataset.brainTitle, section.dataset.brainDescription, section.dataset.brainTags]
      };
      const setCopy = (data, index) => {
        title.textContent = data[0]; description.textContent = data[1]; tags.textContent = data[2];
        count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(items.length).padStart(2, '0')}`;
      };
      const itemIndex = scene => items.findIndex(item => item.dataset.scene === scene);
      const itemCopy = (item, index) => setCopy([item.dataset.title, item.dataset.description, item.dataset.tags], index);
      const pressItem = index => items.forEach((item, itemIndexValue) => item.setAttribute('aria-pressed', String(itemIndexValue === index)));
      const enter = (region, scene, index) => {
        section.classList.remove('is-overview', 'is-head-detail', 'is-body-detail', 'has-head-sensor');
        section.dataset.region = region;
        section.dataset.focusScene = scene || '';
        section.querySelector('[data-focus-card]').setAttribute('aria-hidden',String(!scene || !images[scene]));
        markers.forEach(marker => marker.setAttribute('aria-pressed', String(marker.dataset.regionButton === region)));
        headMarkers.forEach(marker => marker.setAttribute('aria-pressed', 'false'));
        if (region === 'head') section.classList.add('is-head-detail');
        if (region === 'core' || region === 'arm' || region === 'leg') section.classList.add('is-body-detail');
        if (scene && images[scene]) {
          const copy = headCopy[scene];
          image.src = images[scene];
          image.alt = copy ? copy[0] : items[index].dataset.title;
          label.textContent = copy ? copy[0] : items[index].dataset.title;
          focusDescription.textContent = copy ? copy[1] : items[index].dataset.description;
        }
        if (index >= 0) { pressItem(index); itemCopy(items[index], index); }
      };
      const reset = () => {
        section.classList.remove('is-head-detail', 'is-body-detail', 'has-head-sensor');
        section.classList.add('is-overview'); section.dataset.region = 'body';
        section.dataset.focusScene = '';
        section.querySelector('[data-focus-card]').setAttribute('aria-hidden','true');
        markers.forEach(marker => marker.setAttribute('aria-pressed', 'false'));
        headMarkers.forEach(marker => marker.setAttribute('aria-pressed', 'false'));
        if (items[0]) { pressItem(0); itemCopy(items[0], 0); }
      };
      markers.forEach(marker => marker.addEventListener('click', () => {
        const region = marker.dataset.regionButton;
        if (region === 'head') {
          enter('head', null, -1);
          setCopy([section.dataset.headLayerTitle, section.dataset.headLayerDescription, section.dataset.headLayerTags], 0);
          return;
        }
        const scene = region === 'core' ? 'core' : region;
        const index = itemIndex(scene);
        enter(region, scene, index);
      }));
      headMarkers.forEach(marker => marker.addEventListener('click', () => {
        const scene = marker.dataset.headSensor;
        const mappedScene = scene === 'neck' ? 'neck' : scene === 'eye' ? 'eye' : scene === 'brain' ? 'brain' : 'mouth';
        const index = itemIndex(mappedScene);
        enter('head', scene, index);
        section.classList.add('has-head-sensor');
        headMarkers.forEach(button => button.setAttribute('aria-pressed', String(button === marker)));
        setCopy(headCopy[scene], index >= 0 ? index : 0);
      }));
      items.forEach((item, index) => item.addEventListener('click', () => {
        const scene = item.dataset.scene;
        if (scene === 'neck' || scene === 'eye' || scene === 'mouth' || scene === 'brain') { enter('head', scene, index); section.classList.add('has-head-sensor'); }
        else if (scene === 'core') enter('core', scene, index);
        else if (scene === 'leg') enter('leg', scene, index);
        else enter('arm', scene, index);
      }));
      section.querySelector('[data-full-body]').addEventListener('click', reset);
      section.addEventListener('keydown', event => {
        if(event.key === 'Escape' && section.dataset.focusScene === 'neck') {
          event.preventDefault();
          enter('head', null, -1);
          pressItem(-1);
          setCopy([section.dataset.headLayerTitle,section.dataset.headLayerDescription,section.dataset.headLayerTags],0);
          section.querySelector('[data-head-sensor="neck"]').focus({preventScroll:true});
        }
      });
      reset();
    };
    const all = root => (root || document).querySelectorAll('[data-wc-embodied]').forEach(mount);
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => all()) : all();
    document.addEventListener('shopify:section:load', event => all(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warmcore-product-motion"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.initialized === 'true') return;

    const slides = Array.from(root.querySelectorAll('[data-pm-slide]'));
    const dots = root.querySelector('[data-pm-dots]');
    const previous = root.querySelector('[data-pm-prev]');
    const next = root.querySelector('[data-pm-next]');
    const stagePrevious = root.querySelector('[data-pm-stage-prev]');
    const stageNext = root.querySelector('[data-pm-stage-next]');

    if (!slides.length) return;

    root.dataset.initialized = 'true';

    let index = 0;
    let autoplayTimer;
    let transitionTimer;
    let isTransitioning = false;

    const interval = Number(root.dataset.autoplayInterval) || 4200;
    const query = (selector) => root.querySelector(selector);

    if (dots) {
      slides.forEach((slide, slideIndex) => {
        const button = document.createElement('button');

        button.type = 'button';
        button.setAttribute('aria-label', `Show product ${slideIndex + 1}`);
        button.addEventListener('click', () => navigate(slideIndex));

        dots.appendChild(button);
      });
    }

    function go(nextIndex, force = false) {
      const targetIndex = (nextIndex + slides.length) % slides.length;

      if (!force && (isTransitioning || targetIndex === index)) return false;

      index = targetIndex;

      const active = slides[index];

      slides.forEach((slide, slideIndex) => {
        const previousIndex = (index - 1 + slides.length) % slides.length;
        const nextSlideIndex = (index + 1) % slides.length;
        const backIndex = (index + 2) % slides.length;

        slide.classList.toggle('is-active', slideIndex === index);
        slide.classList.toggle('is-left', slideIndex === previousIndex);
        slide.classList.toggle('is-right', slideIndex === nextSlideIndex);
        slide.classList.toggle('is-back', slideIndex === backIndex);
        slide.setAttribute('aria-current', String(slideIndex === index));
      });

      query('[data-pm-kicker]').textContent = active.dataset.kicker || '';
      const activeTitle = active.dataset.title || '';
      const activeBadge = active.dataset.badge || '';
      query('[data-pm-title]').childNodes[0].nodeValue = activeTitle === 'Interactive Model' && activeBadge === 'Flagship' ? root.dataset.pmDefaultHeading + ' ' : `${activeTitle} `;
      const badge = query('[data-pm-badge]');
      if (badge) badge.textContent = activeTitle === 'Interactive Model' && activeBadge === 'Flagship' ? '' : activeBadge;
      query('[data-pm-description]').textContent = active.dataset.description || '';
      query('[data-pm-link]').href = active.dataset.link || '#';

      const configuredAccent = (active.dataset.accent || '').toLowerCase();
      const originalAccent = active.dataset.originalAccent || '#9bbcff';
      const accent = configuredAccent && (configuredAccent !== '#7ddac7' || originalAccent === '#7ddac7') ? configuredAccent : originalAccent;

      root.style.setProperty('--pm-accent', accent);

      if (dots) {
        Array.from(dots.children).forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', String(dotIndex === index));
        });
      }

      window.clearTimeout(transitionTimer);

      isTransitioning = true;
      transitionTimer = window.setTimeout(() => {
        isTransitioning = false;
      }, 680);

      return true;
    }

    function stop() {
      window.clearTimeout(autoplayTimer);
    }

    function start() {
      stop();

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || slides.length < 2) return;

      autoplayTimer = window.setTimeout(() => {
        go(index + 1);
        start();
      }, interval);
    }

    function navigate(nextIndex) {
      if (go(nextIndex)) start();
    }

    if (previous) previous.addEventListener('click', () => navigate(index - 1));
    if (next) next.addEventListener('click', () => navigate(index + 1));
    if (stagePrevious) stagePrevious.addEventListener('click', () => navigate(index - 1));
    if (stageNext) stageNext.addEventListener('click', () => navigate(index + 1));

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          start();
        } else {
          stop();
        }
      });
    }, { threshold: 0.35 }).observe(root);

    go(0, true);
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-wc-product-motion]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));

  if (document.readyState !== 'loading') {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warmcore-product-theater"] && !Shopify.designMode) return;
  try {
    

(()=>{
const setup=(root)=>{if(root.dataset.duoReady==='true')return;root.dataset.duoReady='true';
const cards=[...root.querySelectorAll('[data-duo-card]')],videos=cards.map(c=>c.querySelector('video')),plays=[...root.querySelectorAll('[data-duo-play]')],back=root.querySelector('[data-duo-back]');
const reduce=matchMedia('(prefers-reduced-motion: reduce)'),hover=matchMedia('(hover:hover) and (min-width:721px)'),compact=matchMedia('(max-width:1024px)');
const status=root.querySelector('[data-duo-status]'),header=root.querySelector('.wc-duo__header');
const previewSources=videos.map(v=>v.querySelector('source').dataset.src),positions=[0,0];
let active=0,expanded=false,inView=false,sourceVersion=0,scrolling=false,scrollTimer=0;
root.dataset.hover='';
function stop(){videos.forEach(v=>v.pause());}
function canPreview(){return inView&&!expanded&&!scrolling&&!reduce.matches&&!compact.matches&&!document.hidden;}
function preview(){if(!canPreview()){stop();return;}
active=root.dataset.hover===''?0:Number(root.dataset.hover);
root.dataset.active=String(active);
videos.forEach((v,i)=>{if(i!==active)v.pause();});
{
const v=videos[active],source=v.querySelector('source');
if(!v.src&&!source.hasAttribute('src')){source.src=source.dataset.src;v.load();}
v.muted=true;
if(v.paused)v.play().catch(()=>{});
}}
function select(i){if(expanded)return;active=i;root.dataset.active=String(i);root.dataset.hover=String(i);preview();}
function restoreSource(v,url,time){const ticket=++sourceVersion;v.pause();if(v.src===url||(!v.src&&v.querySelector('source').src===url)){if(v.readyState>=1)v.currentTime=time;return;}
v.addEventListener('loadedmetadata',()=>{if(ticket!==sourceVersion)return;v.currentTime=Math.min(time,Math.max(0,v.duration-.05));},{once:true});v.src=url;v.load();}
videos.forEach(v=>{v.addEventListener('timeupdate',()=>{if(!expanded&&v.currentTime>=4)v.currentTime=0;});v.addEventListener('error',()=>{status.textContent=root.dataset.errorLabel;});});
cards.forEach((card,i)=>{card.addEventListener('pointerenter',()=>{if(hover.matches)select(i);});card.addEventListener('pointerleave',()=>{if(!expanded){root.dataset.hover='';preview();}});card.addEventListener('focusin',()=>{if(!expanded&&document.activeElement.matches(':focus-visible'))select(i);});card.addEventListener('focusout',e=>{if(!expanded&&!card.contains(e.relatedTarget)){root.dataset.hover='';preview();}});});
plays.forEach((button,i)=>button.addEventListener('click',()=>{
active=i;positions[i]=videos[i].currentTime;expanded=true;root.dataset.mode='expanded';root.dataset.active=String(i);root.dataset.hover='';stop();status.textContent='';
cards.forEach((c,j)=>c.hidden=j!==i);plays.forEach((p,j)=>p.setAttribute('aria-expanded',String(j===i)));back.hidden=false;videos[i].parentElement.append(back);
const v=videos[i];v.controls=true;v.loop=false;
const full=v.dataset.fullSrc?new URL(v.dataset.fullSrc,location.href).href:null;
const play=()=>{if(expanded&&active===i&&!document.hidden)v.play().catch(()=>{status.textContent=root.dataset.playbackLabel;});};
if(full&&v.currentSrc!==full){const ticket=++sourceVersion;v.addEventListener('loadedmetadata',()=>{if(ticket!==sourceVersion||!expanded)return;v.currentTime=Math.min(positions[i],Math.max(0,v.duration-.05));play();},{once:true});v.src=full;v.load();}else{if(v.ended)v.currentTime=0;play();}
back.focus({preventScroll:true});
}));
function close(){if(!expanded)return;stop();++sourceVersion;const v=videos[active];const previewTime=v.dataset.fullSrc?positions[active]:v.currentTime%4;v.controls=false;v.loop=true;
restoreSource(v,previewSources[active],previewTime);cards.forEach(c=>c.hidden=false);videos.forEach(v=>{v.controls=false;v.loop=true;});plays.forEach(p=>p.setAttribute('aria-expanded','false'));back.hidden=true;header.append(back);status.textContent='';expanded=false;root.dataset.mode='browse';root.dataset.hover='';plays[active].focus({preventScroll:true});preview();}
back.addEventListener('click',close);root.addEventListener('keydown',e=>{if(e.key==='Escape'&&expanded){e.preventDefault();close();}});
const observer=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting&&entries[0].intersectionRatio>=.15;if(!inView)stop();else if(!expanded)preview();},{threshold:.15});observer.observe(root);
const onScroll=()=>{scrolling=true;if(inView&&!expanded)stop();clearTimeout(scrollTimer);scrollTimer=setTimeout(()=>{scrolling=false;if(inView&&!expanded)preview();},180);};window.addEventListener('scroll',onScroll,{passive:true});
const onVisibility=()=>{if(document.hidden)stop();else if(!expanded)preview();};const onReduce=()=>{if(!expanded)preview();};document.addEventListener('visibilitychange',onVisibility);reduce.addEventListener('change',onReduce);compact.addEventListener('change',onReduce);root.duoCleanup=()=>{stop();++sourceVersion;clearTimeout(scrollTimer);observer.disconnect();window.removeEventListener('scroll',onScroll);document.removeEventListener('visibilitychange',onVisibility);reduce.removeEventListener('change',onReduce);compact.removeEventListener('change',onReduce);};
};const boot=(scope=document)=>scope.querySelectorAll('[data-wc-duo]').forEach(setup);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(),{once:true});else boot();document.addEventListener('shopify:section:load',e=>boot(e.target));document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-wc-duo]').forEach(r=>r.duoCleanup?.()));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wc-about-us-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-wc-about]');
    if (!root) return;
    const hero = root.querySelector('.wc-about__hero');
    const video = root.querySelector('.wc-about__hero-video');
    const replay = root.querySelector('.wc-about__replay');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveal = () => hero.classList.add('is-ended', 'is-copy-visible');
    const play = (restart) => {
      if (!video || reduceMotion) { reveal(); return; }
      hero.classList.remove('is-ended', 'is-copy-visible');
      if (restart) video.currentTime = 0;
      video.play().catch(reveal);
    };
    if (video && !reduceMotion) {
      video.addEventListener('ended', reveal);
      video.addEventListener('error', reveal, { once: true });
      play(false);
    } else { reveal(); }
    if (replay) replay.addEventListener('click', () => play(true));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wc-adult-v2-foundation"] && !Shopify.designMode) return;
  try {
    
const root = document.querySelector('#MainContent:has(#hero-title)');
const bodyPicker = root && root.querySelector('.body-picker');
if (bodyPicker) {
const bindManualPlay = (container) => {
  const video = container.querySelector('video');
  if (!video || container.querySelector('.video-play-overlay')) return;
  const playButton = document.createElement('button');
  playButton.type = 'button';
  playButton.className = 'video-play-overlay';
  playButton.setAttribute('aria-label', 'Play video');
  playButton.addEventListener('click', () => video.play().catch(() => { playButton.hidden = false; }));
  video.addEventListener('play', () => { playButton.hidden = true; });
  video.addEventListener('pause', () => { playButton.hidden = false; });
  video.addEventListener('ended', () => { playButton.hidden = false; });
  container.append(playButton);
};
root.querySelectorAll('.demo-frame video, .head-video video').forEach((video) => bindManualPlay(video.parentElement));
const bodyModels = Object.fromEntries(bodyPicker.dataset.bodyModels.split('~!~').filter(Boolean).map((row) => { const [id, name, subtitle, image, alt, details] = row.split('|'); return [id, { name, subtitle, image, alt, details: details.split('; ').map((item) => item.split('=')) }]; }));

const bodyImage = root.querySelector('#body-image');
const bodyName = root.querySelector('#body-name');
const bodySubtitle = root.querySelector('#body-subtitle');
const bodyDetails = root.querySelector('#body-details');

const experienceFan = root.querySelector('#experience-fan');
const experienceSlides = experienceFan.dataset.slides.split('~!~').filter(Boolean).map((row) => { const [image, alt, title, description] = row.split('|'); return { image, alt, title, description }; });
let activeExperienceSlide = 0;

function showExperienceSlide(index, scrollToCard = false) {
  activeExperienceSlide = (index + experienceSlides.length) % experienceSlides.length;
  [...experienceFan.children].forEach((card, cardIndex) => {
    const active = cardIndex === activeExperienceSlide;
    card.classList.toggle('is-active', active);
    card.setAttribute('aria-pressed', String(active));
    card.style.zIndex = String(active ? experienceSlides.length + 1 : experienceSlides.length - Math.abs(cardIndex - activeExperienceSlide));
    if (active && scrollToCard && window.matchMedia('(max-width: 640px)').matches) {
      experienceFan.scrollTo({left: card.offsetLeft - (experienceFan.clientWidth - card.offsetWidth) / 2, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
  });
}

if (experienceFan) {
  experienceSlides.forEach((slide, index) => {
    const card = document.createElement('button');
    card.type = 'button';
    card.className = 'experience-card';
    card.setAttribute('aria-pressed', 'false');
    card.setAttribute('aria-label', `Show image ${index + 1}: ${slide.title}`);
    const image = document.createElement('img');
    image.src = slide.image;
    image.alt = slide.alt;
    image.loading = 'lazy';
    const caption = document.createElement('span');
    caption.className = 'experience-card__caption';
    const count = document.createElement('span');
    count.className = 'experience-card__count';
    count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(experienceSlides.length).padStart(2, '0')}`;
    const title = document.createElement('span');
    title.className = 'experience-card__title';
    title.textContent = slide.title;
    const description = document.createElement('span');
    description.className = 'experience-card__description';
    description.textContent = slide.description;
    caption.append(count, title, description);
    card.append(image, caption);
    card.addEventListener('click', () => showExperienceSlide(index));
    card.addEventListener('keydown', (event) => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? experienceSlides.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + experienceSlides.length) % experienceSlides.length;
      showExperienceSlide(next, true);
      experienceFan.children[next].focus({preventScroll:true});
    });
    experienceFan.append(card);

  });
  root.querySelector('#experience-prev').addEventListener('click', () => showExperienceSlide(activeExperienceSlide - 1, true));
  root.querySelector('#experience-next').addEventListener('click', () => showExperienceSlide(activeExperienceSlide + 1, true));
  showExperienceSlide(0);

  if ('IntersectionObserver' in window && window.matchMedia('(max-width: 640px)').matches) {
    const fanObserver = new IntersectionObserver((entries) => {
      const mostVisible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (mostVisible && mostVisible.intersectionRatio >= 0.68) {
        showExperienceSlide([...experienceFan.children].indexOf(mostVisible.target));
      }
    }, { root: experienceFan, threshold: [0.68, 0.82, 0.96] });
    [...experienceFan.children].forEach((card) => fanObserver.observe(card));
  }
}

root.querySelectorAll('.body-tab').forEach((tab) => {
  tab.addEventListener('click', () => {
    const model = bodyModels[tab.dataset.body];
    root.querySelectorAll('.body-tab').forEach((item) => {
      const selected = item === tab;
      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-selected', String(selected));
    });
    bodyImage.src = model.image;
    bodyImage.alt = model.alt;
    bodyName.textContent = model.name;
    bodySubtitle.textContent = model.subtitle;
    bodyDetails.replaceChildren(...model.details.map(([label, value]) => {
      const row = document.createElement('div');
      const dt = document.createElement('dt');
      const dd = document.createElement('dd');
      dt.textContent = label;
      dd.textContent = value;
      row.append(dt, dd);
      return row;
    }));
  });
});

const headPicker = root.querySelector('.head-picker');
const headName = root.querySelector('#head-name');
const headVideo = root.querySelector('#head-video');
const headDescription = root.querySelector('#head-description');
const headKicker = root.querySelector('#head-kicker');
const xiaolingFeatures = root.querySelector('#xiaoling-features');
const xiaolingFeatureNote = root.querySelector('.xiaoling-features__note');
const headBlurb = headPicker.dataset.headBlurb;

root.querySelectorAll('.head-option').forEach((option) => {
  option.addEventListener('click', () => {
    const name = option.querySelector('b').textContent.trim();
    const mediaType = option.dataset.type;
    root.querySelectorAll('.head-option').forEach((item) => {
      const active = item === option;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', String(active));
    });
    headName.textContent = name;
    const isXiaoling = option.dataset.name === 'Xiaoling';
    headKicker.textContent = isXiaoling ? headPicker.dataset.bestValueLabel : headPicker.dataset.selectedLabel;
    headDescription.textContent = isXiaoling ? headPicker.dataset.xiaolingDescription : headBlurb;
    xiaolingFeatures.hidden = !isXiaoling;
    xiaolingFeatureNote.hidden = !isXiaoling;
    headVideo.replaceChildren();
    if (mediaType === 'image') {
      const image = document.createElement('img');
      image.src = option.dataset.image;
      image.alt = `${name} ${headPicker.dataset.altSuffix}`;
      headVideo.append(image);
      return;
    }
    const media = document.createElement(mediaType === 'embed' ? 'iframe' : 'video');
    media.title = `${name} ${headPicker.dataset.videoTitleSuffix}`;
    if (mediaType === 'file') {
      media.src = option.dataset.video;
      media.preload = 'metadata';
      media.poster = option.dataset.poster || option.dataset.image;
      media.loop = true;
      media.playsInline = true;
      media.controls = true;
    } else {
      media.src = option.dataset.video;
      media.loading = 'lazy';
      media.allow = 'fullscreen';
      media.referrerPolicy = 'no-referrer';
    }
    headVideo.append(media);
    if (mediaType !== 'image') bindManualPlay(headVideo);
    headVideo.setAttribute('aria-label', `${name} selected head sculpt video`);
  });
});



}

  } catch(e) { console.error(e); }
})();
})();
